import { Box, CloseButton, Drawer } from "@mantine/core";
import { FC, useState } from "react";
import LeadForm from "./LeadForm";

interface Props {
  practitionerInfo: any;
  onClose: () => void;
}

const LeadDrawer: FC<Props> = ({
  practitionerInfo,
  onClose,
}) => {
  const [isFormValid, setIsFormValid] = useState<boolean>(false);
  return (
    <Drawer
      opened={!!practitionerInfo}
      zIndex={5001}
      size="xl"
      radius="30px 30px 0 0"
      onClose={() => onClose()}
      position="bottom"
      variant={!isFormValid
        ? "baseball-card--red"
        : "baseball-card--green"}
      styles={{
        header: {
          display: "none"
        },
        body: {
          height: "100%",
          boxSizing: "border-box"
        }
      }}
    >
      <Box
        bg={isFormValid ? "#00DC49" : "#E64B37"}
        display="block"
        w="100%"
        pos="absolute"
        top={0}
        left={0}
        lh="25px"
        ta="center"
        c="white">
        {isFormValid ? 
          "Not in Netsuite: Ready to Submit" : "Not in Netsuite: Incomplete Lead"}
      </Box>
      <Box
        p={0}
        pt={40}
        w="100%"
        h="100%"
        pos="relative"
        style={{
          boxSizing: "border-box"
        }}>
        <Box
          c="#4F7D9C"
          fz="h4"
          fw="bold"
          pos="absolute"
          top={40}
          left={10}>
          Create New Lead
        </Box>
        <CloseButton
          size="xl"
          pos="absolute"
          top={25}
          right={-10}
          style={{
            zIndex: 5002,
          }}
          onClick={() => {
            onClose();
          }} />
        <Box pos="absolute" top={75}
          style={{
            borderTop: "1px solid #8B8B8B",
            width: "100%",
          }}>
        </Box>
        <Box pt={55} 
          style={{
            position: "relative",
            boxSizing: "border-box",
            overflowY: "hidden",
            height: "100%",
          }}>
          <LeadForm
            practitionerInfo={practitionerInfo}
            onFormStateChange={(s) => setIsFormValid(s)}
            onFormSubmitted={() => onClose()}
          />
        </Box>
      </Box>
    </Drawer>
  );
};

export default LeadDrawer;